<template>
  <section id="clinic-hospital" class="bg-grey-light3 lg:mb-16 mb-10">
    <div class="md:container px-4 py-14">
      <div class="flex flex-wrap lg:flex-nowrap">
        <div class="w-full lg:w-1/2 lg:mr-4 lg:mb-0 mb-6">
          <img v-lazy-load data-src="@/assets/img/img-for-clinic-rs.png" alt="" class="mx-auto">
        </div>
        <div class="w-full lg:w-1/2">
          <p class="tracking-widest uppercase text-primary font-rubik-medium">
            {{ $t('hospitalAndClinic.title') }}
          </p>
          <h3 class="font-bree-serif md:text-3xl mt-4 mb-6">
            {{ $t('hospitalAndClinic.subtitle') }}
          </h3>
          <p class="md:text-lg mb-8">
            {{ $t('hospitalAndClinic.desc') }}
          </p>
          <template v-for="(check,index) in checkLists">
            <div :key="index" class="flex items-center mb-3">
              <img v-lazy-load data-src="@/assets/icon/icon-checkbox.svg" alt="" class="inline-block mr-3">
              <span class="text-lg font-rubik-medium">{{ $t(check.name) }}</span>
            </div>
          </template>
          <div class="flex flex-wrap sm:flex-nowrap mt-6">
            <button
              class="btn btn-success sm:w-2/5 sm:mr-6 sm:mb-0 mb-4 w-full text-xl uppercase"
              @click="$store.commit('SET_MODAL_REGISTER', true)"
            >
              {{ $t('signup') }}
            </button>
            <button class="btn btn-primary sm:w-2/5 w-full text-xl uppercase" @click="modal = true">
              {{ $t('signin') }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!--    yes-modal login-->
    <yes-modal
      v-if="modal"
      :image-modal="false"
      text-center
      centered
      bg-backdrop="bg-premier-blue"
      bg-opacity="bg-opacity-90"
      :show-close="true"
      @close="modal = false"
    >
      <div class="lg:px-10 px-4">
        <!-- <img v-lazy-load data-src="@/assets/icon/icon-yd.svg" alt="" class="h-full"> -->
        <img v-lazy-load data-src="@/assets/icon/icon-new-yd.svg" alt="" width="131" height="56">
        <p class="mt-10 text-left text-xl text-center" v-html="$t('titleModalHeader', {type: 'YesDok Network'})" />
        <div class="flex flex-wrap lg:flex-nowrap justify-center items-center my-6">
          <div class="w-full lg:w-1/3 lg:mr-4 lg:mb-0 mb-4">
            <div
              class="card flex items-center justify-center border-2 border-blue2 cursor-pointer hover:bg-light-blue"
              style="min-height: 180px;"
              :class="{'bg-light-blue': loginType === 'HOSPITAL'}"
              @click="loginType = 'HOSPITAL'"
            >
              <div>
                <img v-lazy-load data-src="@/assets/icon/icon-rs.svg" alt="" class="mx-auto">
                <p class="text-primary font-rubik-medium mt-4">
                  {{ $t('hospital') }}
                </p>
              </div>
            </div>
          </div>
          <div class="w-full lg:w-1/3 lg:mr-4 lg:mb-0 mb-4">
            <div
              class="card flex items-center justify-center border-2 border-blue2 cursor-pointer hover:bg-light-blue"
              style="min-height: 180px"
              :class="{'bg-light-blue': loginType === 'CLINIC'}"
              @click="loginType = 'CLINIC'"
            >
              <div>
                <img v-lazy-load data-src="@/assets/icon/icon-clinic.svg" alt="">
                <p class="text-primary font-rubik-medium mt-5">
                  {{ $t('clinic') }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <button class="btn btn-success rounded-full px-14 uppercase my-8" :disabled="!loginType" @click="handleContinue">
          {{ $t('continue') }}
        </button>
      </div>
    </yes-modal>
  </section>
</template>

<script>
export default {
  name: 'HospitalClinic',
  data: () => ({
    checkLists: [
      {
        name: 'checkListClinic.first'
      },
      {
        name: 'checkListClinic.second'
      },
      {
        name: 'checkListClinic.third'
      },
      {
        name: 'checkListClinic.fourth'
      }
    ],
    modal: false,
    loginType: null
  }),
  methods: {
    handleContinue () {
      if (this.loginType === 'CLINIC') {
        window.location.href = `${process.env.BASE_CLINIC_URL}/auth/login`
      } else {
        window.location.href = `${process.env.BASE_HOSPITAL_URL}/auth/login`
      }
    }
  }
}
</script>

<style scoped>

</style>
